/**
 * Agent Inbox discovery widgets.
 *
 * Two visible surfaces, one data source:
 *   - Sidebar link (#nav-agent-inbox)           under INTELLIGENCE group
 *   - Topbar mailbox icon (#topbar-agent-inbox) next to the notification bell
 *
 * Both show a pending-count badge. Poll /api/agent-actions/counts every 60s,
 * and fire an immediate refresh on 'heist:agent-inbox-changed' (dispatched by
 * the inbox page after approve/reject so the badge updates instantly).
 *
 * Pro-tier only. For non-Pro users both widgets stay hidden.
 */

const POLL_INTERVAL_MS = 60_000;

function isProTier() {
    const u = window.__auth__ || {};
    if (['admin', 'angel_admin', 'god_admin'].includes(u.role)) return true;
    // Mirror server/middleware/tier.js MCP_ALLOWED_TIERS — trial users
    // get full Pro access during their evaluation window.
    return ['trial', 'pro', 'business', 'founder', 'agency'].includes(u.tier);
}

let pollTimer = null;
let currentFetch = null;

function setBadge(el, count) {
    if (!el) return;
    if (count > 0) {
        el.hidden = false;
        el.textContent = count > 99 ? '99+' : String(count);
    } else {
        el.hidden = true;
    }
}

async function fetchPendingCount() {
    try {
        const r = await fetch('/api/agent-actions/counts', { credentials: 'include' });
        if (!r.ok) return 0;
        const j = await r.json();
        return Number(j.pending) || 0;
    } catch (_) {
        return 0;
    }
}

async function refresh() {
    if (currentFetch) return currentFetch;
    const sidebarLink = document.getElementById('nav-agent-inbox');
    const sidebarBadge = document.getElementById('nav-agent-inbox-count');
    const topbarBtn = document.getElementById('topbar-agent-inbox');
    const topbarBadge = document.getElementById('topbar-agent-inbox-count');

    if (!isProTier()) {
        if (sidebarLink) sidebarLink.style.display = 'none';
        if (topbarBtn) topbarBtn.hidden = true;
        return;
    }

    // Reveal surfaces for Pro users
    if (sidebarLink) sidebarLink.style.display = '';
    if (topbarBtn) topbarBtn.hidden = false;

    currentFetch = fetchPendingCount().finally(() => { currentFetch = null; });
    const count = await currentFetch;
    setBadge(sidebarBadge, count);
    setBadge(topbarBadge, count);
}

function start() {
    refresh();
    if (pollTimer) clearInterval(pollTimer);
    pollTimer = setInterval(refresh, POLL_INTERVAL_MS);
}

function stop() {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
}

export function initAgentInboxBadge() {
    // Start once the user is authed. The auth event fires from main.js / boot.
    if (window.__auth__) start();
    window.addEventListener('heist:auth-changed', () => {
        if (window.__auth__) start();
        else stop();
    });
    // Any page can fire this to request an immediate re-check.
    window.addEventListener('heist:agent-inbox-changed', () => { refresh(); });
    // Update when user returns to the tab after a while.
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden && window.__auth__) refresh();
    });
}
